import React, { Component } from 'react';
import { connect } from 'react-redux';

import FireDuration from './FireDuration/FireDuration';
import SeismicLoads from './SeismicLoads/SeismicLoads';
import TableWrapper from './DesignLoadingTable';

import { loadTypes } from './misc/combination.class';
import '../styles.scss';
import Standard from './Standard';
import { updateExtraCombinationField } from '@reducers/selectors/loads/actions';
import { BRAND } from '@config';
import { brandList, standardList } from '../../../../app.values';

// eslint-disable-next-line react/prefer-stateless-function
class DesignLoading extends Component {
  
  render() {
    return (
      <div className="d-flex flex-column">
        <TableWrapper />

        {!this.props.isImporting && this.props.combination && !this.props.combination.isRemoved &&
        <div>
          {this.props.loadType === loadTypes.STANDARD && 
          Number(this.props.designStd) !== standardList["Masonry"] &&
          Number(this.props.designStd) !== standardList["AnnexC"] &&
          (BRAND !== brandList.Ramset || 
            Number(this.props.designStd) === standardList["EU"] || 
            Number(this.props.designStd) === standardList["AS5216"]) &&
            <Standard onUpdate={this.props.updateExtraField.bind(null, this.props.activeIndex)} combination={this.props.combination} />
          }

          {this.props.loadType === loadTypes.SEISMIC &&
            <SeismicLoads 
              onUpdate={this.props.updateExtraField.bind(null, this.props.activeIndex)} 
              combination={this.props.combination} 
              designStd={this.props.designStd} 
              country={this.props.country}/>
          }

          {this.props.loadType === loadTypes.FIRE &&
            <FireDuration onUpdate={this.props.updateExtraField.bind(null, this.props.activeIndex)} combination={this.props.combination} />
          }
        </div>
        }
      </div>
      );
  }

}

const mapState = state => ({
  combination: state.selectors.loads[state.main.appType].designLoadingData.find(i => i.isActive),
  loadType: (() => {
    const active = state.selectors.loads[state.main.appType].designLoadingData.find(i => i.isActive);

    if (active) {
      return active.loadType;
    }
  })(),
  activeIndex: state.selectors.loads[state.main.appType].activeCombinationIndex,
  designStd: state.main.localization.designStandard,
  country: state.main.localization.country,
  appStatus: state.main.status, // use it as a hack to render a potential language change
  isImporting: state.selectors.loads[state.main.appType].importState.isImporting
});

const mapDispatch = dispatch => ({
  updateExtraField: (index, options) => dispatch(updateExtraCombinationField(index, options))
});

export default connect(mapState, mapDispatch)(DesignLoading);



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/index.js